module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"age":"age"},"de":{"age":"Jahre"}}')
  delete Component.options._Ctor
}
